import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

import { Health } from '@/hooks/api/health/types';

export default function useGetApiHealth() {
  const queryKey = ['api', 'health', 'api'];
  const queryClient = useQueryClient();

  const { data, isPending } = useQuery<Health>({
    queryKey,
    queryFn: async () => {
      try {
        const { data } = await axios.get<Health>(`/${queryKey.join('/')}`);
        return data;
      } catch {
        return { status: 'DOWN' };
      }
    },
    retry: false,
    refetchInterval: () => {
      const queryState = queryClient.getQueryState(queryKey);
      return (queryState?.data as Health | undefined)?.status === 'UP' ? 60 * 1000 : 5 * 1000; // 1 minute or 5 seconds
    },
    staleTime: 10 * 1000,
  });

  return {
    isApiAvailable: data?.status === 'UP', isPending,
  };
}
